import ChapterList from 'routes/ChapterList/ChapterList';

export default ChapterList;
